import { hideKeyboardOnPressEnter } from "@src/appV2/lib/utils/capacitor";
import { Input } from "@src/appV2/redesign/system/ui-components";

interface ChatSearchBarProps {
  value: string;
  onChange: (value: string) => void;
}

export function ChatListSearchBar(props: ChatSearchBarProps) {
  const { value, onChange } = props;

  return (
    <Input
      fullWidth
      aria-label="Search by workplace name"
      size="medium"
      type="search"
      placeholder="Search by workplace name"
      value={value}
      onChange={(event) => {
        onChange(event.target.value);
      }}
      onKeyPress={hideKeyboardOnPressEnter}
    />
  );
}
